import React from "react";

const BlogFilled = ({color = "currentColor"}) => (
    <svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
        <path
            d="M23.532.524c-.675.11-4.69.81-8.715 2.577a.51.51 0 00-.305.467c0 .957-.529 1.94-1.029 2.658V4.59a.511.511 0 00-.729-.462c-5.48 2.604-9.97 10.233-7.075 14.179l-5.315 5.32a.512.512 0 00.722.723l5.308-5.315c2.731 2.099 6.89-.085 9.68-2.541l-2.49-2.493a.512.512 0 01.72-.723l2.52 2.524c.356-.343.39-.374.716-.72l-1.725-1.735a.51.51 0 11.724-.72l1.676 1.685c4.115-4.995 5.907-12.83 5.987-13.187.09-.39-.285-.72-.67-.602z"
            fill={color}
            fillRule="nonzero"
        />
    </svg>
);

export default BlogFilled;
